import React from 'react';

interface SchemaMarkupProps {
  schema: string;
}

const SchemaMarkup: React.FC<SchemaMarkupProps> = ({ schema }) => {
  return (
    <script 
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: schema }}
    />
  );
};

export default SchemaMarkup;
